import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
    Table,
    Button,
    Alert
} from 'reactstrap'

import api from '../api'
import NotificationService from '../../../services/NotificationService.js'

import './TenantsList.scss'

class TenantsList extends Component {

    static propTypes = {
        onEdit: PropTypes.func.isRequired
    }

    state = {
        tenants: [],
        loading: true,
        error: null
    }

    componentDidMount() {
        this.loadTenants()
    }

    loadTenants = async() => {
        try {
            this.setState({ loading: true })
            const response = await api.getAllTenants()
            
            if (response && response.data) {
                this.setState({
                    tenants: response.data.value || [],
                    loading: false
                })
            } else {
                this.setState({
                    loading: false,
                    error: 'Geen tenants data ontvangen'
                })
            }
        } catch (err) {
            this.setState({
                loading: false,
                error: err.message
            }, () =>
                NotificationService.notifyError({
                    title: err.message || 'Fout',
                    message: 'Er is een fout opgetreden tijdens het ophalen van tenants.'
                })
            )
        }
    }

    handleEdit = tenant => {
        this.props.onEdit(tenant)
    }

    handleDelete = async tenant => {
        if (window.confirm(`Weet u zeker dat u tenant "${tenant.description}" wilt verwijderen?`)) {
            try {
                await api.deleteTenant(tenant.id)
                NotificationService.notifySuccess({
                    title: 'Succes',
                    message: `Tenant "${tenant.description}" is verwijderd.`
                })
                this.loadTenants()
            } catch (err) {
                NotificationService.notifyError({
                    title: err.message || 'Fout',
                    message: 'Er is een fout opgetreden tijdens het verwijderen van de tenant.'
                })
            }
        }
    }

    render() {
        const { tenants, loading, error } = this.state

        if (loading) {
            return <div>Tenants laden...</div>
        }

        if (error) {
            return (
                <Alert color="danger">
                    Fout bij het laden van tenants: {error}
                </Alert>
            )
        }

        if (tenants.length === 0) {
            return (
                <Alert color="info">
                    Er zijn nog geen tenants aangemaakt.
                </Alert>
            )
        }

        return (
            <div className="tenants-list">
                <Table responsive striped>
                    <thead>
                        <tr>
                            <th>Identifier</th>
                            <th>Beschrijving</th>
                            <th>Tenant ID</th>
                            <th>Acties</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tenants.map(tenant => (
                            <tr key= { tenant.id } >
                                <td>{tenant.identifier}</td>
                                <td>{tenant.description}</td>
                                <td>{tenant.tenantId || '-'}</td>
                                <td>
                                    <Button 
                                        color="primary" 
                                        size="sm" 
                                        className="mr-2"
                                        onClick= { () => this.handleEdit(tenant) }
                                    >
                                        Bewerken
                                    </Button>
                                    <Button 
                                        color="danger" 
                                        size="sm"
                                        onClick= { () => this.handleDelete(tenant) }
                                    >
                                        Verwijderen
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        )
    }
}

export default TenantsList